import React from "react";
import propTypes from "prop-types";
import { Link } from "../../utils/customLink";

import CtaButton from "../../components/shared/buttons/ctaButton";
import Image from "../../components/image";
import { useSiteMetadata } from "../../hooks/useSiteMetadata";

import GoogleScholarLogo from "../../images/icons/google-scholar-logo.svg";
import RecruitmentIcon from "../../images/icons/recruitment-icon.inline.svg";

export const FullwidthBannerBGImage = ({
  bannerTitle,
  bannerSubTitle,
  bannerSubTitleImg,
  showGradient,
  showBGImage,
  showIllustration,
  imageSrc,
  illustrationSrc,
  gradientColors,
  gradientDefaultClass,
  showCTAButton,
  ctaLabel,
  ctaUri,
  ctaPreset,
  ctaContainerClass,
  bgImageDefaultClass,
  buttonStyle,
  labelClass,
  arrowClass,
  bgImageClass,
  containerClass,
  bannerTitleClass,
  subTitleClass,
  bannerInnerContainerClass,
  bannerOuterContainerClass,
  bannerGoogleScholar
}) => {
  const { siteMetadata } = useSiteMetadata();
  const { social_media } = siteMetadata ?? {};
  const { google_scholar } = social_media ?? {};

  return (
    <section
      className={`relative w-full flex flex-col items-center justify-center ${containerClass}`}
    >
      {showBGImage && (
        <Image
          imageAlt={""}
          imageClass={`${bgImageDefaultClass} ${bgImageClass}`}
          image={imageSrc?.gatsbyImage}
          sourceUrl={imageSrc?.sourceUrl}
        />
      )}

      {showIllustration && <>{illustrationSrc}</>}

      {showGradient && (
        <div className={`${gradientColors} ${gradientDefaultClass} `} />
      )}

      <div className={bannerOuterContainerClass}>
        <div className={bannerInnerContainerClass}>
          {bannerTitle && (
            <div
              className={bannerTitleClass}
              dangerouslySetInnerHTML={{ __html: bannerTitle }}
            />
          )}

          {bannerSubTitle && (
            <div className="flex flex-col md:flex-row">
              {bannerSubTitleImg && (
                <RecruitmentIcon className="block w-5 h-auto mt-8 md:mt-4 fill-gray-generic" />
              )}
              <div
                className={subTitleClass}
                dangerouslySetInnerHTML={{ __html: bannerSubTitle }}
              />
            </div>
          )}
          {bannerGoogleScholar && (
            <div
              className={
                "pt-5 text-white text-base flex flex-col sm:flex-row relative"
              }
            >
              {bannerGoogleScholar}

              <Image
                imageAlt={""}
                image={""}
                imageClass={`w-32 sm:w-28 h-auto mt-3 sm:pl-1 sm:mt-1`}
                sourceUrl={GoogleScholarLogo}
              />
              <Link
                to={google_scholar}
                target={"gvi_blank"}
                rel={"no_follow"}
                className={"absolute top-0 left-0 right-0 bottom-0"}
              />
            </div>
          )}

          {showCTAButton && (
            <div className={ctaContainerClass}>
              <CtaButton
                preset={ctaPreset}
                ctaLabel={ctaLabel}
                buttonStyle={buttonStyle}
                labelClass={labelClass}
                arrowClass={arrowClass}
                to={ctaUri}
              />
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

FullwidthBannerBGImage.propTypes = {
  bannerTitle: propTypes.string.isRequired,
  bannerSubTitle: propTypes.string,
  bannerSubTitleImg: propTypes.bool,
  bannerGoogleScholar: propTypes.string,
  imageSrc: propTypes.object,
  gradientColors: propTypes.string,
  bgImageClass: propTypes.string,
  containerClass: propTypes.string,
  bannerTitleClass: propTypes.string,
  subTitleClass: propTypes.string,
  bannerInnerContainerClass: propTypes.string,
  bannerOuterContainerClass: propTypes.string,
  showGradient: propTypes.bool,
  showBGImage: propTypes.bool,
  showIllustration: propTypes.bool,
  showCTAButton: propTypes.bool,
  ctaLabel: propTypes.string,
  ctaUri: propTypes.string
};
FullwidthBannerBGImage.defaultProps = {
  bannerTitle: `<span> Discover a world of</span> <br /> conservation opportunities`,
  bannerSubTitle: "",
  bannerSubTitleImg: false,
  bannerGoogleScholar: "",
  imageSrc: {
    gatsbyImage: null,
    sourceUrl:
      "https://www.gvi.co.uk/wp-content/uploads/2022/11/589696546-2022-nov-09-13-34-13-000000-55.jpg"
  },
  gradientColors: "from-generic-bg via-generic-bg",
  gradientDefaultClass:
    "bg-gradient-to-t sm:bg-gradient-to-r h-full w-full sm:w-3/5 absolute left-0 z-10 sm:block",
  bgImageDefaultClass:
    "relative sm:absolute z-0 top-0 right-0 left-0 bottom-0 ",
  bgImageClass: "h-full w-full object-cover object-center",
  containerClass: "sm:px-4 sm:py-12 gvi-light-gray-bg h-full sm:h-96",
  showGradient: true,
  showBGImage: true,
  showCTAButton: false,
  ctaLabel: "",
  ctaUri: "",
  ctaContainerClass: "mx-auto w-fill sm:w-1/5 pt-10",
  ctaPreset: "secondary",
  buttonStyle: "",
  arrowClass: "",
  labelClass: "text-base leading-genericCta font-bold pr-2",
  bannerTitleClass: "banner-heading no-br sm:show-br leading-snug h1",
  subTitleClass: "banner-heading no-br sm:show-br leading-snug",
  bannerInnerContainerClass: "w-full sm:w-4/5 mx-auto",
  bannerOuterContainerClass:
    "relative z-20 flex justify-center items-center px-5 sm:px-0 mt-10 sm:mt-0 mb-16 sm:mb-0 w-full h-full"
};
